import styled from 'styled-components';
import { theme } from '../../styles/theme';
export const Table = styled.table `
  border-collapse: collapse;
  width: 100%;

  tbody tr {
    &:hover {
      background: ${theme.colors.backgroundLightest};
    }
  }

  th,
  td {
    border-block: 1px solid ${theme.colors.borderLight};
    padding: ${theme.spacing.md} ${theme.spacing.md};

    @media only screen and (min-width: 600px) {
      padding-inline: ${theme.spacing.lg};
    }
  }

  th {
    ${theme.typography.label};
    text-align: left;
  }

  td {
    ${theme.typography.bodyLG};

    &:first-child {
      ${theme.typography.headingXS};
      color: ${theme.colors.text};
    }

    &:last-child {
      width: 24px;
    }
  }
`;
